import React from "react";

type Props = {
  title: string;
  description: string;
};

function NotShowContentInMobileSize({ title, description }: Props) {
  return (
    <div
      className={`lg:tw-hidden  tw-h-48 ${
        title ? "tw-p-6" : "tw-p-2"
      } tw-bg-white tw-rounded-2xl  tw-shadow tw-flex-col tw-justify-start tw-items-center tw-gap-6 tw-inline-flex`}
    >
      <div className="tw-self-stretch tw-justify-center tw-items-start tw-gap-6 tw-inline-flex">
        <div className="tw-grow tw-shrink tw-basis-0 tw-flex-col tw-justify-start tw-items-start tw-gap-4 tw-inline-flex">
          <div className="tw-text-gray-700 tw-text-xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
            {title}
          </div>
          <div className="tw-self-stretch tw-h-24 tw-px-6  tw-bg-gray-50 tw-rounded-lg tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
            <div className="tw-grow tw-shrink tw-basis-0 tw-text-gray-700 tw-text-sm tw-font-bold tw-font-['Lexend'] tw-leading-tight">
              {description}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotShowContentInMobileSize;
